angular.module("persons")

    .controller("PersonsImportCtrl", ['$scope', '$stateParams',
        function ($scope, $stateParams) {
            $scope.people = $stateParams.people;
            $scope.person_type = $stateParams.person_type;
    }]);